import { render } from "./CaseWizardModal.vue?vue&type=template&id=1c32136e&scoped=true"
import script from "./CaseWizardModal.vue?vue&type=script&lang=js"
export * from "./CaseWizardModal.vue?vue&type=script&lang=js"

import "./CaseWizardModal.vue?vue&type=style&index=0&id=1c32136e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c32136e"]])

export default __exports__